import {
    HttpClient,
    HttpErrorResponse,
    HttpHeaders,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { BehaviorSubject, Observable, tap } from 'rxjs'
import { AsyncFormValidation } from '../../interceptors/error.interceptor'
import { Address, AddressDTO } from '../../models/location.interface'
import { RequestService } from '../request/request.service'
import { Pagination } from '../../models/pagination.interface'
import { QueryGet } from '../../shared/query-types'

@Injectable({
    providedIn: 'root',
})
export class AddressService {
    httpOptions = {
        headers: new HttpHeaders({}),
    }

    private apiUrl = environment.service_1 + 'address/'
    private address = new BehaviorSubject<Address[]>([])
    address$ = this.address.asObservable()

    private asyncErrorValidation =
        new BehaviorSubject<AsyncFormValidation | null>(null)
    asyncErrorValidation$ = this.asyncErrorValidation.asObservable()

    private addressSelected = new BehaviorSubject<Address | null>(null)
    $addressSelected = this.addressSelected.asObservable()

    constructor(
        private requestService: RequestService,
        private http: HttpClient
    ) {}

    setAddress(address: Address[]) {
        this.address.next(address)
    }

    setAddresses(address: Address) {
        this.addressSelected.next(address)
    }

    allAddress(): Observable<Address[]> {
        return this.http.get<Address[]>(this.apiUrl, {
            headers: this.httpOptions.headers,
        })
    }

    allAddresses(queryParams: QueryGet): Observable<Pagination<Address[]>> {
        return this.requestService.get<Address[]>(this.apiUrl, queryParams)
    }

    deleteAddress(id: number): Observable<void> {
        return this.http.delete<void>(this.apiUrl + id + '/')
    }

    updateAddress(id: number, address: AddressDTO & { id: number }) {
        return this.http.put<Address>(this.apiUrl + id + '/', address).pipe(
            tap({
                error: (err: HttpErrorResponse) => {
                    this.asyncErrorValidation.next(err.error)
                },
            })
        )
    }
}
